import { globalColors } from 'globalStyle';
import { animations } from 'theme';

export const styles = {
  innerCardContent: {
    //*vertical padding must stay in px: a % padding resolves against the card WIDTH (top/bottom too), so cards of
    //*different widths would get different inner heights and their dividers/values would sit at different levels
    padding: '12px 4%',
    borderRadius: 'inherit',
    ...animations.appearanceEffect,
    '@media (min-width: 2250px)': {
      padding: '12px 1%',
    },
  },
  upperRow: {
    borderBottom: '1px solid #e6e9ed',
  },
  value: {
    fontWeight: 700,
    fontSize: '32px',
    marginLeft: '7px',
    color: globalColors.regular.text.primary,
    lineHeight: '26px',
  },
  units: {
    fontWeight: 500,
    fontSize: '12px',
    marginTop: '12px',
    marginRight: '5px',
    color: globalColors.regular.text.primary,
    lineHeight: '14px',
  },
  bottomRow: {
    maxHeight: '46px',
  },
  description: {
    fontWeight: 400,
    fontSize: '12px',
    color: globalColors.regular.text.grey,
    lineHeight: '14px',
  },
  rightColumn: {
    padding: '2%',
    backgroundColor: globalColors.regular.background.greyCardBackground,
    borderRadius: '8px',
  },
  //*matches the primary value row, whose height comes from the 32px system icon, so both descriptions sit on the same line
  secondaryValueRow: {
    minHeight: '32px',
  },
  secondaryDivider: {
    width: '1px',
    alignSelf: 'stretch',
    backgroundColor: globalColors.regular.background.greyDivider,
    margin: '0 10px',
  },
  rightColumnUpperRow: {},
  rightColumnDivider: {
    height: '1px',
    backgroundColor: globalColors.regular.background.greyDivider,
    marginTop: '7px',
  },
  rightColumnBottomRow: {},
  rightColumnContent: {
    marginLeft: '5px',
  },
  rightColumnContentUpperRow: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: globalColors.regular.text.primary,
  },
  rightColumnContentBottomRow: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14px',
    color: globalColors.regular.text.grey,
  },
  rightColumnArrowPlaceHolder: {},
};
